/**
 * utils/taskStatus.js — единые предикаты статуса Работы.
 *
 * После появления «На согласовании» (tasks.awaiting_client) и статуса
 * `cancelled` проверка `status !== 'done'` перестала значить «Работа идёт»:
 * отменённая тоже не done. Все места, где раньше стояло `!== 'done'`, ходят
 * сюда — осмысленно, по одному (awaiting_client_implementation_plan.md).
 *
 *  · isActiveTask     — pending / in_progress (не закрыта). Для просрочки,
 *                       экстренных пульсаций, «идёт работа».
 *  · isClosedTask     — done / cancelled.
 *  · isAwaitingTask   — pending + «На согласовании» (даты нет, клиент не ответил).
 *  · isCancelledTask  — «Отменена».
 *  · isExecutableTask — можно выполнять: активна и не на согласовании. Гейт для
 *                       кнопок исполнения (старт, пауза, быстрое «Готово», фото…);
 *                       сервер всё равно вернёт 409 task_awaiting_client / task_cancelled.
 */
export const isActiveTask = (t) => !!t && (t.status === 'pending' || t.status === 'in_progress');
export const isClosedTask = (t) => !!t && (t.status === 'done' || t.status === 'cancelled');
export const isAwaitingTask = (t) => !!t && t.status === 'pending' && !!t.awaiting_client;
export const isCancelledTask = (t) => !!t && t.status === 'cancelled';
export const isExecutableTask = (t) => isActiveTask(t) && !t.awaiting_client;

// Полных суток с ISO-даты (SQLite-формат 'YYYY-MM-DD HH:MM:SS' тоже подходит); null — даты нет/битая.
export const daysSince = (iso) => {
  const ts = iso ? Date.parse(String(iso).replace(' ', 'T')) : NaN;
  if (Number.isNaN(ts)) return null;
  return Math.max(0, Math.floor((Date.now() - ts) / 86400000));
};
